import './LoadMoreButton.css';

type Props = {
  remaining: number;
  nextBatch: number;
  onClick: () => void;
  onShowAll?: () => void;
};

const LoadMoreButton = ({ remaining, nextBatch, onClick, onShowAll }: Props) => {
  if (remaining <= 0 || nextBatch <= 0) return null;

  const showAll = Boolean(onShowAll) && remaining > nextBatch;

  return (
    <div className="load-more-wrap">
      <button type="button" className="btn-load-more" onClick={onClick}>
        Показать ещё {nextBatch}
        {remaining > nextBatch ? (
          <span className="load-more-rest"> (ещё {remaining})</span>
        ) : null}
      </button>
      {showAll ? (
        <button type="button" className="btn-load-more" onClick={onShowAll}>
          Показать все
        </button>
      ) : null}
    </div>
  );
};

export default LoadMoreButton;
